import React, {useState, useEffect, useRef} from 'react'
import './profile.css';
import firebase from './../../config/fbConfig.js'
import { Link } from 'react-router-dom'
import axios from 'axios'
import xButton from './../assets/xButton.png'
import noProfile from './../assets/noprofile.png'
import ExtraOptions from './../extraOptions/extraOptions.js';
import PrivateAlbum from './../privateAlbum/privateAlbum.js';

const db = firebase.firestore();

function Profile(props) {
	let [profile, setProfile] = useState({
		nickname: '',
		bio: '',
		pic: false,
		deletehash: false,
		country: '',
		countryIMG: '',
		gender: false,
		motto: false,
		hobbies: false,
		favoritefood: false,	
		skype: false})
	// state for the pic file, selectedpicture = the file, namePic = the name of the pic
	const [selectedPicture, setPic] = useState(null)
	const [namePic, setNamePic] = useState(false)
	// state for check if the user wants edit
	const [wantEdit, setEdit] = useState(true)
	// state to save the input values in case the user wants to edit
	const [inputValues, setInputValues] = useState({})
	let [album, setAlbum] = useState([])
	let albumLength;
	let [missingAlbum, setMissingAlbum] = useState([])
	const loadingAnim = useRef(null)
	const forceUpdate = React.useState()[1].bind(null, {})

	// This useEffect is used to gain the attrbiutes about the proifle 
	useEffect(() => {
		if (props.user!=null) {
		db.collection("accounts").doc(props.user.uid).get().then((doc) => {
				    if (doc.exists) {
				        setProfile({
				        	nickname: doc.data().nickname,
				        	bio: doc.data().bio,
				        	pic: doc.data().pic!=null ? doc.data().pic : false,
				        	deletehash: doc.data().deletehash!=null ? doc.data().deletehash : false,
				        	country: doc.data().country,
				        	countryIMG: doc.data().countryIMG,
				        	age: doc.data().age!=null ? doc.data().age : false,
				        	gender: doc.data().gender!=null ? doc.data().gender : false,
				        	motto: doc.data().motto!=null ? doc.data().motto : false,
				        	hobbies: doc.data().hobbies!=null ? doc.data().hobbies : false,
				        	favoritefood: doc.data().favoritefood!=null ? doc.data().favoritefood : false,
				        	skype: doc.data().skype!=null ? doc.data().skype : false
				        }) 
				        
				        setTimeout(() => {
				        	document.getElementById('profile').hidden = false;
				        	// In case it's not a phone and need to change the right value of menu (because there's scroll)
				        	if(!props.isPhone.current && document.body.scrollHeight > window.innerHeight) {
							 	document.getElementById('menu').style.right = '25px';
							} 
				    	}, 100);

				    } else {
				        // doc.data() will be undefined in this case
				        console.log("No such document!");
				    }
				}).catch(function(error) {
				    console.log("Error getting document:", error);
				});

		db.collection("album").doc(props.user.uid).collection("album").get().then((doc) => {		
			for (let i=0; i<doc.docs.length; i++) {
				album = [...album, doc.docs[i].data()];

				if (i==(doc.docs.length-1)) {
					setAlbum(album);
					let albumLength = album.length;
					if (albumLength<12) {
						for (let i=1; i<=(12-albumLength); i++) {
							missingAlbum.push("")
						}
						setMissingAlbum(missingAlbum);
						forceUpdate();
					}
				}
			}
		})
	}
	}, [props.user])

	let GeneratePic = (e) => {
		setPic(e.target.files[0]);
		setNamePic(e.target.files[0].name);
	}

	let UploadPic = (e) => {
		 if (selectedPicture==null) {
		 	alert(`You haven't uploaded any picture yet.`);
		 	return;
		 }

		 if (selectedPicture.type.match(/image/) && selectedPicture.type !== 'image/svg+xml') {

		 	const loading = e.target.nextSibling;
		 	loading.hidden = false;
		 	let UpOrDown = 0;
		 	loadingAnim.current = window.setInterval(() => {
				if (UpOrDown==0) {
					loading.innerHTML += ".";
					if (loading.innerHTML=="Loading....") {
						UpOrDown = 1;
					}
				} else {
					loading.innerHTML = loading.innerHTML.slice(0, loading.innerHTML.length-1); // Removing last letter every 300ms until "Loading"
					if (loading.innerHTML=="Loading") {
						UpOrDown = 0;
					} 
				}
			}, 300);
		 	
		 	let fd = new FormData();
		 	fd.append('image', selectedPicture);

		 	const options = {
			  headers: {'Authorization': 'Client-ID 805e6c0b10879f4'}		  
			};

			axios.post('https://api.imgur.com/3/image', fd, options).then(response => {
				// To update UI
				setProfile({...profile, pic: `${response.data.data.link}`, deletehash: `${response.data.data.deletehash}`});
				// To update the document
				profile = {...profile, pic: `${response.data.data.link}`, deletehash: `${response.data.data.deletehash}`};
				db.collection("accounts").doc(props.user.uid).set(profile);
				// To remove the pic's name after upload
				setNamePic(null)
				clearInterval(loadingAnim);
				loading.hidden = true;
			});

		 } else {
		 	alert("Hey the file you uploaded isn't a picture")
		 }
	}

	let removePic = () => {
		const imageDeleteHash = profile.deletehash;
		const options = {
			  headers: {'Authorization': 'Client-ID 805e6c0b10879f4'}		  
			};
		axios.delete(`https://api.imgur.com/3/image/${imageDeleteHash}`, options).then(response => {
			// To update UI
			setProfile({...profile, pic: false, deletehash: false});
			// To update the document
			profile = {...profile, pic: false, deletehash: false};
			db.collection("accounts").doc(props.user.uid).set(profile);
			// To remove the pic's name after upload
			setNamePic(null);
		})
	}
	
	let UpdateProfile = () => {
		const Gender = document.getElementById('gender');
		const Age = document.getElementById('age');
		const Motto = document.getElementById('motto');
		const Skype = document.getElementById('skype');
		const Hobbies = document.getElementById('hobbies');
		const Favfood = document.getElementById('favoritefood');

		let Added = {};
		console.log(Age.tagName);
		(Gender.tagName=='SELECT') ?  (Added.gender = Gender.value) : (Added.gender=Gender.innerHTML);
		if (Age.tagName=='INPUT')  {
			// If this isn't a number, so throw an error
			if (!/^[1-9][0-9]*$/gm.test(Age.value)) {
				alert("You didn't enter a valid number for age.");
				return;
			}
			if (Age.value<7) {
				alert("You aren't that young I know this");
				return;
			}
			if (Age.value>120) {
				alert("Arent you too old for this place?");
				return;
			}
			(Added.age = Age.value) 
		} else {
			(Added.age=Age.innerHTML)
		}
		if (Motto.tagName=='INPUT' || Skype.tagName=='INPUT' || Hobbies.tagName=='INPUT' || Favfood.tagName=='INPUT') {
			if (Motto.value.length > 25 || Skype.value.length > 25 || Hobbies.value.length > 25 || Favfood.value.length > 25) {
				alert("You can't enter more than 25 letters.")
				return;
			}
		}
		(Motto.tagName=='INPUT') ?  (Added.motto = Motto.value) : (Added.motto=Motto.innerHTML);
		(Skype.tagName=='INPUT') ?  (Added.skype = Skype.value) : (Added.skype=Skype.innerHTML);
		(Hobbies.tagName=='INPUT') ?  (Added.hobbies = Hobbies.value) : (Added.hobbies=Hobbies.innerHTML);
		(Favfood.tagName=='INPUT') ?  (Added.favoritefood = Favfood.value) : (Added.favoritefood=Favfood.innerHTML);

		for (let [key, value] of Object.entries(Added)) {
			profile[key] = value;
		}

		setProfile(profile);
		db.collection('accounts').doc(props.user.uid).update(profile);
		alert('Successfully updated profile!');
		setTimeout(() => window.location.reload(), 500);
	}
	

	let editContent = () => {
		const editButton = document.getElementById('editButton');
		const cancelButton = document.getElementById('cancelButton');
		editButton.hidden = true;
		cancelButton.hidden = false;

		setInputValues({
			gender: document.getElementById('age').value,
			age: document.getElementById('age').innerHTML,
			motto: document.getElementById('motto').innerHTML,
			skype: document.getElementById('skype').innerHTML,
			hobbies: document.getElementById('hobbies').innerHTML,
			favfood: document.getElementById('favoritefood').innerHTML
		})

		setEdit(false);

	}

	let cancelEdit = () => {
		const editButton = document.getElementById('editButton');
		const cancelButton = document.getElementById('cancelButton');
		editButton.hidden = false;
		cancelButton.hidden = true;
		setEdit(true);
	}

	return (
		<div id="profile" hidden>
			
			{props.user!=null && 
				<div id="content">

			<h1>Welcome to your profile</h1>

			<div id="leftSide">
			{(profile.pic!=false) ? 
				<div>
					<span className="attrName"> Profile Picture:</span> <img alt="Profile Pic" src={profile.pic}></img>
					<ul id="moreOptionsExistingPic">
						<li style={{borderBottom: '3px solid black'}}>
							<button onClick={removePic} style={{padding: '10px', display: 'block', margin: '0 auto', borderRadius: '10px', border: '2px solid black', cursor: 'pointer', outline: 'none'}}>Remove Picture</button>
						</li>

						<li>
							<label htmlFor="file-upload" id="labelUpload">
							{namePic && <span id="namePic">{namePic}</span>}
							    Upload a new picture
							 </label>
							<input id="file-upload" type="file" onChange={GeneratePic}/>
							{(window.innerWidth>415) ? <button onClick={UploadPic}>Upload Picture!</button> : <button onClick={UploadPic}>UPLOAD</button> }
						</li>
					</ul>
				</div>

			 : // If there's no profile picture so: 
			 
			 	<div id="leftBlock">
				<div>You haven't uploaded a profile picture yet :(</div>
				But you can do it now!
				
				<label htmlFor="file-upload" id="labelUpload">
				{namePic && <span id="namePic">{namePic}</span>}
				    Custom Upload
				 </label>
				<input id="file-upload" type="file" onChange={GeneratePic}/>
				<button onClick={UploadPic}>Upload Picture!</button>
				<div style={{position: 'absolute', bottom: '45px', right: '35px'}} hidden>Loading</div>
				</div>
				}
			</div>

			<div id="rightSide">
				{(window.innerWidth<850) && <h2 style={{textAlign: 'center', paddingTop: '40px'}}>Information about you:</h2>}
				<div>
				<span className="attrName"> Nickname:</span>
				<span className="attr">{profile.nickname}</span>
				</div>

				<div>
				<span className="attrName"> Bio:</span>
				<span className="attr">{profile.bio}</span>
				</div>

				<div style={{position: 'relative', display: 'inline-block'}}>
				<span className="attrName"> Country:</span>
				<span style={{position: 'absolute', left: '200px'}}>{profile.country}</span>
				<img src={profile.countryIMG} style={{position: 'absolute', bottom: '7px', left: '137px', width: '50px', height: '50px', marginLeft: '10px'}} alt="Country"/>
				</div>
				
				{/* If there's attrbiute so show the attrbiute, else give the option to fill input*/}
				{(!profile.age || !profile.gender || !profile.skype || !profile.hobbies || !profile.favoritefood) && <div id="missingDetails">I noticed you have some missing details in your profile. <div>You can always add more details about you :)</div></div>}

				{(profile.gender && wantEdit) ? 
					<div>
					<span className="attrName"> Gender:</span>
					<span className="attr" id="gender" style={{border: 'none', padding: '0px', width: 'auto'}}>{profile.gender}</span>
					</div> :

					<div>
					<span className="attrName"> Gender:</span>
					<select id="gender" defaultValue={inputValues.gender}>
						<option disabled></option>
						<option value="Male">Male</option>
						<option value="Female">Female</option>
						<option value="Other">Other</option>
					</select>
					</div>
				}

				{(profile.age && wantEdit) ? 
					<div>
					<span className="attrName"> Age:</span>
					<span className="attr" id="age">{profile.age}</span>
					</div> :

					<div>
					<span className="attrName"> Age:</span>
					<input id="age" type="text" placeholder="You didn't fill in age" defaultValue={inputValues.age}/>
					</div>
				}

				{(profile.motto && wantEdit) ?
					<div>
					<span className="attrName"> Motto:</span>
					<span className="attr" id="motto">{profile.motto}</span>
					</div> :
					
					<div> 
					<span className="attrName"> Motto:</span>
					<input id="motto" type="text" placeholder="You didn't fill a motto" defaultValue={inputValues.motto}/>
					</div>
				}

				{(profile.hobbies && wantEdit) ?
					<div>
					<span className="attrName"> Hobbies:</span>
					<span className="attr" id="hobbies">{profile.hobbies}</span>
					</div> :
					
					<div> 
					<span className="attrName"> Hobbies:</span>
					<input id="hobbies" type="text" placeholder="You didn't fill in your hobbies" defaultValue={inputValues.hobbies}/>
					</div>
				}


				{(profile.favoritefood && wantEdit) ?
					<div>
					<span className="attrName"> Favorite food:</span>
					<span className="attr" id="favoritefood">{profile.favoritefood}</span>
					</div> :
					
					<div> 
					<span className="attrName"> Favorite food:</span>
					<input id="favoritefood" type="text" placeholder="You didn't fill your favorite food" defaultValue={inputValues.favfood}/>
					</div>
				}

				{(profile.skype && wantEdit) ?
					<div><span className="attrName"> Skype:</span>
					<span className="attr" id="skype">{profile.skype}</span>
					</div> :

					<div>
					<span className="attrName"> Skype:</span>
					<input id="skype" type="text" placeholder="You didn't fill Skype username" defaultValue={inputValues.skype}/>
					</div>
				}

				
				<button id="editButton" onClick={editContent}>Edit Profile</button>
				<button id="cancelButton" onClick={cancelEdit} hidden>Cancel Edit</button>
				{(!wantEdit || !profile.gender || !profile.age || !profile.motto || !profile.skype || !profile.hobbies || !profile.favoritefood) && <button onClick={UpdateProfile}>Update Profile</button>}
			</div>
			</div>
			}

			<h2>My Album</h2>
			
				<PrivateAlbum album={album} user={props.user} isPhone={props.isPhone} profile={profile} setAlbum={setAlbum} missingAlbum={missingAlbum} setMissingAlbum={setMissingAlbum}/>
				
					 
					
				</div>

		
	)
}

export default Profile